"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _Stat = _interopRequireDefault(require("../../molecules/Stat/Stat"));
var _HorizontalStat = _interopRequireDefault(require("../../molecules/HorizontalStat/HorizontalStat"));
var _ImpactDataCallout = _interopRequireDefault(require("../../components/ImpactDataCallout/ImpactDataCallout"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _excluded = ["headingCopy", "bottomCopy", "statsItems", "hasHorizStat", "horizStatItem"];
var _templateObject, _templateObject2, _templateObject3;
var StyledHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h2: true,
    white: true,
    bold: true,
    className: className
  }, " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\ntext-align: center;\npadding-left: 10%; \npadding-right: 10%;\n"])));
var StyledStat = _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    max-width: 100%;\n    max-height: 150px;\n    text-align: center;\n\n    @media (min-width: ", ") {\n    }\n\n    @media (min-width: ", ") {\n    }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledPageGrid = (0, _styledComponents.default)(_PageGrid.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    background-color: var(--bf-core-teal);\n    text-align: center;\n    border-top: transparent;\n    border-bottom: transparent;\n    border-left: transparent;\n    border-left-width: 0px !important;\n    border-right: transparent;\n    border-right-width: 0px !important;\n    border-width: thick;\n    border-style: solid;\n    padding-top: 25px;\n    padding-bottom: 25px;\n"])));
var Statistics = function Statistics(_ref2) {
  var headingCopy = _ref2.headingCopy,
    bottomCopy = _ref2.bottomCopy,
    statsItems = _ref2.statsItems,
    hasHorizStat = _ref2.hasHorizStat,
    horizStatItem = _ref2.horizStatItem,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  if (hasHorizStat) {
    return _react.default.createElement(StyledPageGrid, props, _react.default.createElement(_Grid.default, Object.assign({
      container: true
    }, props), _react.default.createElement(_Grid.default, Object.assign({
      item: true,
      justifyContent: "center",
      style: {
        textAlign: 'center'
      }
    }, props), _react.default.createElement(StyledHeading, Object.assign({
      xs: 12
    }, props), headingCopy)), _react.default.createElement(_Grid.default, {
      container: true,
      sx: {
        display: {
          xl: 'block',
          xs: 'none',
          sm: 'none',
          md: 'block'
        }
      },
      justifyContent: "center"
    }, _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
      variant: "ThreeThreeThreeRatio",
      justifyContent: "center"
    }, props), statsItems.map(function (statItem) {
      return _react.default.createElement(_Stat.default, Object.assign({}, props, {
        value: statItem.value,
        caption: statItem.caption
      }));
    })), _react.default.createElement(_HorizontalDivider.default, {
      dividerwhite: true
    }), _react.default.createElement(_HorizontalStat.default, {
      value: horizStatItem.value,
      caption: horizStatItem.caption
    }, " ")), _react.default.createElement(_Grid.default, {
      container: true,
      sx: {
        display: {
          xl: 'none',
          xs: 'block',
          sm: 'block',
          md: 'none'
        }
      }
    }, _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
      variant: "ThreeThreeThreeRatio",
      justifyContent: "center"
    }, props), statsItems.map(function (statItem) {
      return _react.default.createElement(_Stat.default, Object.assign({}, props, {
        value: statItem.value,
        caption: statItem.caption
      }));
    })), _react.default.createElement(_HorizontalDivider.default, {
      dividerwhite: true
    }), _react.default.createElement(_ImpactDataCallout.default, {
      xs: 3,
      sm: 3,
      dataPoint: horizStatItem.value,
      dataDescription: horizStatItem.caption
    }, " "))));
  } else {
    return _react.default.createElement(StyledPageGrid, props, _react.default.createElement(_Grid.default, Object.assign({
      container: true
    }, props), _react.default.createElement(_Grid.default, Object.assign({
      item: true,
      justifyContent: "center",
      style: {
        textAlign: 'center'
      }
    }, props), _react.default.createElement(StyledHeading, Object.assign({
      xs: 12
    }, props), headingCopy)), _react.default.createElement(_Grid.default, {
      container: true
    }, _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
      variant: "ThreeThreeThreeRatio",
      justifyContent: "center"
    }, props), statsItems.map(function (statItem) {
      return _react.default.createElement(_Stat.default, Object.assign({}, props, {
        value: statItem.value,
        caption: statItem.caption
      }));
    })))));
  }
};
var _default = Statistics;
exports.default = _default;